import React, { useEffect, useState } from 'react';
import useParam from '../../../../context/ParamContext';
import Chip from '@mui/material/Chip';
import { CheckboxUI } from '../../../Interface';
import { Box } from '@mui/material';

const ChipContent = ({ eventInfo, selectedTaskState }) => {
  const { selectedTaskIds, setSelectedTaskIds } = selectedTaskState;
  const task = eventInfo.event._def.extendedProps.eventData;

  const setChipContent = () => {
    if (!task) {
      return null;
    }

    const fLine = task.simpleTaskName ? `F: ${task.simpleTaskName}` : '\u00A0';
    const pLine = task.project?.projectName ? `P: ${task.project.projectName}` : '\u00A0';
    const gLine = task.generatedType === '' ? '\u00A0' : task.generatedType;
    const g2Line = task.generatedOrderNumber === '' ? '\u00A0' : task.generatedOrderNumber;

    const relatedResources = task.resources?.map((r) => r?.resourceTwo?.name).filter(Boolean) || [];

    const stopFcPropagation = (e) => {
      e.stopPropagation();
    };

    return (
      <span className="block" style={{ marginTop: '2px', marginBottom: '2px' }}>
        <Box display="flex" alignItems="center">
          {task.resourceFourId && (
            <CheckboxUI
              onClick={stopFcPropagation}
              sx={{ m: 0, ml: -0.2, p: 0 }}
              checked={selectedTaskIds.includes(task.simpleTaskId)}
              onChange={() =>
                setSelectedTaskIds((prev) =>
                  prev.includes(task.simpleTaskId)
                    ? prev.filter((simpleTaskId) => simpleTaskId !== task.simpleTaskId)
                    : [...prev, task.simpleTaskId]
                )
              }
            />
          )}
          {pLine}
        </Box>
        {fLine}
        <br />
        {gLine}
        <br />
        <p className="text-[12.5px]">{g2Line}</p>
        {relatedResources.length > 0 && (
          <div style={{ marginTop: '4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {relatedResources.map((name, idx) => (
              <Chip
                key={idx}
                label={name}
                title={name}
                size="small"
                sx={{
                  backgroundColor: '#e0e0e0',
                  color: '#424242',
                  height: 20,
                  '.MuiChip-label': { paddingLeft: 6, paddingRight: 6 },
                }}
              />
            ))}
          </div>
        )}
      </span>
    );
  };

  return <div>{setChipContent()}</div>;
};

export default ChipContent;
